/** Mixin to make element-ui date-picker logic reusable in all of the different tabs */
export default {
  computed: {
    dateRange: {
      get() {
        return this.$store.getters['user/dateRange']
      },
      set(val) {
        this.$store.commit('user/setDateRange', val)
      }
    }
  },
  methods: {
    // Function to calculate datepicker shortcuts for Element UI
    getShortcuts() {
      const shortcuts = []
      const today = moment()

      // Last 10 days or current month if today is less than 10
      if (today.date() < 10) {
        const startOfCurrentMonth = today.clone().startOf('month')
        shortcuts.push({
          text: this.$t('shortcuts.current_month'),
          onClick: () => {
            this.dateRange = [startOfCurrentMonth.toDate(), today.toDate()]
          }
        })
      } else {
        const startOfLast10Days = today.clone().subtract(9, 'days')
        shortcuts.push({
          text: this.$t('shortcuts.last_10_days'),
          onClick: () => {
            this.dateRange = [startOfLast10Days.toDate(), today.toDate()]
          }
        })
      }

      // Last Month
      const startOfLastMonth = today.clone().subtract(1, 'months').startOf('month')
      const endOfLastMonth = today.clone().subtract(1, 'months').endOf('month')
      shortcuts.push({
        text: this.$t('shortcuts.last_month'),
        onClick: () => {
          this.dateRange = [startOfLastMonth.toDate(), endOfLastMonth.toDate()]
        }
      })

      // This Quarter
      const startOfCurrentQuarter = today.clone().startOf('quarter')
      shortcuts.push({
        text: this.$t('shortcuts.this_quarter'),
        onClick: () => {
          this.dateRange = [startOfCurrentQuarter.toDate(), today.toDate()]
        }
      })

      // Last Quarter
      const startOfLastQuarter = today.clone().subtract(1, 'quarter').startOf('quarter')
      const endOfLastQuarter = today.clone().subtract(1, 'quarter').endOf('quarter')
      shortcuts.push({
        text: this.$t('shortcuts.last_quarter'),
        onClick: () => {
          this.dateRange = [startOfLastQuarter.toDate(), endOfLastQuarter.toDate()]
        }
      })

      // This year
      const startOfYear = today.clone().startOf('year')
      shortcuts.push({
        text: this.$t('shortcuts.this_year'),
        onClick: () => {
          this.dateRange = [startOfYear.toDate(), today.toDate()]
        }
      })

      // Last year
      const startOfLastYear = today.clone().subtract(1, 'year').startOf('year')
      const endOfLastYear = startOfLastYear.clone().endOf('year')
      shortcuts.push({
        text: this.$t('shortcuts.last_year'),
        onClick: () => {
          this.dateRange = [startOfLastYear.toDate(), endOfLastYear.toDate()]
        }
      })

      return shortcuts
    },

    // Function to disable dates 3 months to either side of a received date
    getDisabledDate(referenceDate) {
      const date = moment()
      const refDate = moment(referenceDate)
      const threeMonthsBefore = refDate.clone().subtract(3, 'months')
      const threeMonthsAfter = refDate.clone().add(3, 'months')
      const isFutureDate = moment().isBefore(date)

      // Disable dates 3 months before and after the reference date, and future dates
      return date.isAfter(threeMonthsAfter) || date.isBefore(threeMonthsBefore) || isFutureDate
    },

    // Get picker options including shortcuts and disabled date function
    getPickerOptions() {
      let disabledDate = this.getDisabledDate(this.givenDate)
      const options = {
        shortcuts: this.getShortcuts(),
        onPick: dates => {
          console.log('Date range picked', dates)
          if (!_.isEmpty(dates.minDate) && !_.isEmpty(dates.maxDate)) {
            this.dateRange = [dates.minDate, dates.maxDate]
          } else if (!_.isEmpty(dates.minDate)) {
            disabledDate = this.getDisabledDate(dates.minDate)
          } else {
            disabledDate = this.getDisabledDate(dates.maxDate)
          }
        },
        disabledDate
      }

      return options
    }
  }
}
